import { METRIC_COLUMN_IDS, METRIC_COLUMN_TITLES } from "./metricColumns";
const getForwarderInputsTableElements = () => {
  const tableLayout = {
    entityTableId: "forwarder-inputs",
    defaultPageSize: 50,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: [
      "title",
      "type",
      "input_profile_id",
      "forwarder_title",
      "forwarder_status",
      "forwarder_version",
      "input_state",
      "traffic_last_minute",
      "address",
      "port"
    ],
    defaultColumnOrder: [
      "title",
      "type",
      "input_profile_id",
      "input_state",
      "traffic_last_minute",
      METRIC_COLUMN_IDS.messagesPerStream,
      METRIC_COLUMN_IDS.associatedStreams,
      METRIC_COLUMN_IDS.failureCount,
      "address",
      "port",
      "forwarder_title",
      "forwarder_status",
      "forwarder_version"
    ]
  };
  const additionalAttributes = [
    { id: "address", title: "Address" },
    { id: "port", title: "Port", type: "INT" },
    { id: "forwarder_status", title: "Forwarder status" },
    { id: "forwarder_version", title: "Forwarder Version" },
    { id: "traffic_last_minute", title: "Traffic / min" },
    {
      id: METRIC_COLUMN_IDS.messagesPerStream,
      title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.messagesPerStream]
    },
    {
      id: METRIC_COLUMN_IDS.associatedStreams,
      title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.associatedStreams]
    },
    { id: METRIC_COLUMN_IDS.failureCount, title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.failureCount], type: "INT" }
  ];
  return {
    tableLayout,
    additionalAttributes
  };
};
export default getForwarderInputsTableElements;
